import { Translate } from '@dreryk/react-common';
import { Clipboard, SecondaryText, StrongText, StyledFlex, Text } from '@dreryk/react-components';

import { translationKeys } from '../translations';

const t = translationKeys.mainMenuTileItem.summaryModal;

type AiAssistantMainMenuTileItemSummaryUnassignedNotesProps = {
   unassigned: string;
};

export const AiAssistantMainMenuTileItemSummaryUnassignedNotes = (
   props: AiAssistantMainMenuTileItemSummaryUnassignedNotesProps
): JSX.Element | null => {
   const notes = Array.from(
      new Set(
         props.unassigned
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
      )
   );

   if (notes.length === 0) {
      return null;
   }

   return (
      <StyledFlex direction={'column'} gap={8} width={'100%'}>
         <StyledFlex direction={'column'}>
            <StrongText testId={'unassignedTitle'}>
               <Translate>{t.unassignedTitle}</Translate>
            </StrongText>
            <SecondaryText testId={'unassignedInfo'} text={t.unassignedInfo} />
         </StyledFlex>

         {notes.map((note, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StyledFlex key={index} gap={'8px'} alignItems={'center'}>
               <Text testId={'unassignedNote'}>{note}</Text>
               <Clipboard value={note} />
            </StyledFlex>
         ))}
      </StyledFlex>
   );
};
